<div class="eidos-error-dialog">
  <h1 class="eidos-error-dialog-title">{{ error.name }}</h1>
  <div class="eidos-error-dialog-content">
    <h6>{{ now | date:'dd/MM/YYYY HH:mm' }} - {{ !!url ? url : '' }}</h6>
    <h6>User: {{ user.username }} {{ user.isImpersonated ? '(Impersonated)' : '' }} - {{ user.company }}<br />{{ user.token }}</h6>
    <h4 class="core-error-dialog-message">{{ error.message }}</h4>
    <div *ngIf="error.stack" [innerHtml]="error.stack"></div>
    <p>{{ userAgent }}</p>
    <p>In no info are provided, try to see browser debugger console, try to reload the page.</p>
  </div>
  <div class="eidos-error-dialog-actions">
    <button class="eidos-button eidos-button-normal eidos-button-success" type="button" [cdkCopyToClipboard]="error.name + '<br />' + error.message + '<br />' + error.stack">Copy info</button>
    <button class="eidos-button eidos-button-normal eidos-button-cancel" type="button" (click)="close()">Close</button>
  </div>
</div>
